import React, { useState } from "react";
import { Form, Input, Button, Card, message } from "antd";
import { MailOutlined, LockOutlined } from "@ant-design/icons";
import { adminLogin } from "../../../services/AdminPortalAPIs";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";

const AdminLogin: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      const response = await adminLogin(values);
      const {
        status,
        message: responseMessage,
        token,
        user_name,
      } = response.data;

      if (status) {
        localStorage.setItem("admin_token", token);
        localStorage.setItem("admin_name", user_name);

        message.success("Login successful!");
        navigate("/admin-portal/dashboard");
      } else {
        message.error(responseMessage || "Login failed. Please try again.");
      }
    } catch (err) {
      const error = err as AxiosError<{ message: string }>;
      const errorMessage =
        error?.response?.data?.message ||
        "An unexpected error occurred. Please try again.";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container" style={{ backgroundImage: "url(/images/Loading-Background.jpg)" }}>
      <div className="dt-logo-loading-scr">
        <img src="/images/dt-logo-white.svg" alt="Logo" />
      </div>
      <Card className="login-card">
        <div className="heading-primary" style={{ marginBottom: 20 }}>
          Admin Login
        </div>
        <Form
          name="admin_login"
          onFinish={onFinish}
          layout="vertical"
          className="login-form"
          disabled={loading}
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { required: true, message: "Please input your email!" },
              {
                type: "email",
                message: "Please enter a valid email address!",
              },
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder="admin@datatram.com"
              size="large"
              aria-label="Email"
            />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            rules={[
              { required: true, message: "Please input your password!" },
              { min: 8, message: "Password must be at least 8 characters" },
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="Enter your password"
              size="large"
              aria-label="Password"
            />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="button button--primary"
              size="large"
              block
              loading={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AdminLogin;
